import TwitterIcon from '@/components/component-library/Icon/types/Twitter';
import InstagramIcon from '@/components/component-library/Icon/types/Instagram';
import SpotifyIcon from '@/components/component-library/Icon/types/Spotify';
import FacebookIcon from '@/components/component-library/Icon/types/Facebook';
import SoundcloudIcon from '@/components/component-library/Icon/types/Soundcloud';
import BandcampIcon from '@/components/component-library/Icon/types/Bandcamp';
import BeatportIcon from '@/components/component-library/Icon/types/Beatport';
import DiceIcon from '@/components/component-library/Icon/types/Dice';
import DiscogsIcon from '@/components/component-library/Icon/types/Discogs';
import ResidentAdvisorIcon from '@/components/component-library/Icon/types/ResidentAdvisor';
import YoutubeIcon from '@/components/component-library/Icon/types/Youtube';
import AppleIcon from '@/components/component-library/Icon/types/Apple';

export const PLATFORM_KEY_FACEBOOK = 'facebook';
export const PLATFORM_KEY_INSTAGRAM = 'instagram';
export const PLATFORM_KEY_SOUNDCLOUD = 'soundcloud';
export const PLATFORM_KEY_SPOTIFY = 'spotify';
export const PLATFORM_KEY_TWITTER = 'twitter';
export const PLATFORM_KEY_YOUTUBE = 'youtube';
export const PLATFORM_KEY_BANDCAMP = 'bandcamp';
export const PLATFORM_KEY_RESIDENT_ADVISOR = 'residentAdvisor';
export const PLATFORM_KEY_APPLE = 'apple';
export const PLATFORM_KEY_MIXCLOUD = 'mixcloud';
export const PLATFORM_KEY_DISCOGS = 'discogs';
export const PLATFORM_KEY_BEATPORT = 'beatport';
export const PLATFORM_KEY_DICE = 'dice';
export const PLATFORM_KEY_SEE_TICKETS = 'seeTickets';
export const PLATFORM_KEY_SKIDDLE = 'skiddle';

const SUPPORTED_PLATFORMS = [
  {
    patterns: ['fb.', 'facebook.'],
    displayText: 'Facebook',
    platform: PLATFORM_KEY_FACEBOOK,
    IconComponent: FacebookIcon
  },
  {
    patterns: ['instagr.', 'instagram.'],
    displayText: 'Instagram',
    platform: PLATFORM_KEY_INSTAGRAM,
    IconComponent: InstagramIcon
  },
  {
    patterns: ['snd.sc', 'soundcloud.'],
    displayText: 'Soundcloud',
    platform: PLATFORM_KEY_SOUNDCLOUD,
    IconComponent: SoundcloudIcon
  },
  {
    patterns: ['spotify.', 'spotify:'],
    displayText: 'Spotify',
    platform: PLATFORM_KEY_SPOTIFY,
    IconComponent: SpotifyIcon
  },
  {
    patterns: ['t.co', 'twitter'],
    displayText: 'Twitter',
    platform: PLATFORM_KEY_TWITTER,
    IconComponent: TwitterIcon
  },
  {
    patterns: ['youtube.co'],
    displayText: 'Youtube',
    platform: PLATFORM_KEY_YOUTUBE,
    IconComponent: YoutubeIcon
  },
  {
    patterns: ['bandcamp'],
    displayText: 'Bandcamp',
    platform: PLATFORM_KEY_BANDCAMP,
    IconComponent: BandcampIcon
  },
  {
    patterns: ['ra.co'],
    displayText: 'Resident Advisor',
    platform: PLATFORM_KEY_RESIDENT_ADVISOR,
    IconComponent: ResidentAdvisorIcon,
    isTicketLink: true
  },
  {
    patterns: ['apple.'],
    displayText: 'Apple',
    platform: PLATFORM_KEY_APPLE,
    IconComponent: AppleIcon
  },
  // {
  //   patterns: ['mixcloud.'],
  //   displayText: 'Mixcloud',
  //   platform: PLATFORM_KEY_MIXCLOUD,
  //   IconComponent: MixcloudIcon
  // },
  {
    patterns: ['discogs.'],
    displayText: 'Discogs',
    platform: PLATFORM_KEY_DISCOGS,
    IconComponent: DiscogsIcon
  },
  {
    patterns: ['beatport'],
    displayText: 'Beatport',
    platform: PLATFORM_KEY_BEATPORT,
    IconComponent: BeatportIcon
  },
  {
    patterns: ['dice.fm'],
    displayText: 'Dice',
    platform: PLATFORM_KEY_DICE,
    IconComponent: DiceIcon,
    isTicketLink: true
  },
  {
    patterns: ['seetickets.'],
    displayText: 'See Tickets',
    platform: PLATFORM_KEY_SEE_TICKETS,
    isTicketLink: true
  },
  {
    patterns: ['skiddle.'],
    displayText: 'Skiddle',
    platform: PLATFORM_KEY_SKIDDLE,
    isTicketLink: true
  }
];

export default SUPPORTED_PLATFORMS;